<template>
  <div class="programPage"   v-wechat-title="this.title">
   <div class="container">
    <div class="programContainer">
       
      <div class="comPage-compere">
        <div class="comMessage programMsg">
      
          <div class="comMsg">
              <p class="comname">{{programMsg.title}}</p>
              <div class="programMsg">
                <p class="introce">
                  <font>电台:</font>
                  <span>
                  {{programMsg.radio_name}}
                  </span>
                </p>
                <p class="broadcastTime">
                  <font>频率:</font>
                  <span>
                  {{programMsg.channel_name}}
                  </span>
                </p>
                <p class="broadcastTime">
                  <font>播出时间:</font>
                  <span>
                  {{programMsg.date_show}}
                  </span>
                </p>
              </div>
          </div>
        </div>


       
      </div>
      <div class="compereMsg">
          <div class="headPhoto"  v-for="(item,index) in compereHeadPhoto" :key="index" >
            <div class="min-photo" v-if="index<5">
             <img :src="item.avatar" alt="" style="background:black;">
            </div>
             <div class="min-name" v-if="index<5">
               <span>{{item.nickname}}</span>
            </div>
          </div>
         
      </div>
      <div class="downloadApp" @click="toDownloadpage">
        <p>
         <img src="../../assets/downNew.png" alt="">
         </p>
      </div>

    </div>
    <spliteBold></spliteBold>
     <myfooter></myfooter>
  
    </div>
  </div>
</template>

<script>
import  myfooter from '../commen/myfooter'
import  programcommen from '../commen/programcommen'
import  spliteBold from '../commen/spliteBold'
import cbct from '../../../static/js/base.js'
import toast from '../commen/toast.vue'
import qs from 'qs'
let baseurl="http://api.dev.cbct.cn/"
export default {
  name: 'pro-page',
  props: {
    msg: String
  },
 
  data(){
    return {
      programMsg:[],
      compereHeadPhoto:[],
      recommendProgram:[],
      number:'',
      type:'',
      isendShare:'',
      title:"",
      appName:"-听见广播",
     

      
    }
  },
  methods:{
    toDownloadpage(){//点击下载
      this.$router.push({path:"downloadApp?isFrom=programRecorded"});
    },
  
    
  },

   
  created(){
    let self=this;
    self.number=self.$route.query.number;
    self.type=self.$route.query.type;
    self.isendShare=self.$route.query.isendShare;
    self.$api.post(cbct.baseurl+"share/home-page",qs.stringify({
        'number':this.number,
        'type':this.type,
      })).then(function(res){
         if (res.c==cbct.code.successCode) {
            if(res.d.info.is_del=='1'){
                    // console.log(res.d.info.is_del)
                     self.$router.push({
                        path:'delPage'
                    })
                    return;
                  }
              self.programMsg=res.d.info
              self.compereHeadPhoto=res.d.info.hosts
              self.recommendProgram=res.d.recommend.programme
              self.title=res.d.info.title+self.appName//节目主页title
              if(res.d.recommend.programme.length>0) {
                  self.programStopRecommend=res.d.recommend.programme;
              }else if(res.d.recommend.programme.length == 0){
                  self.programStopRecommend= ['none'];
              }
         }else{
           self.bus.$emit('toast',{show:true,title:res.m})
             
        }
      }).catch((res)=>{
          // this.bus.$emit('toast',{show:true,title:'服务器错误'})

      });
   
  },
  components: {

       myfooter,
       spliteBold,
      //  toast,
      //  programcommenNew,

  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.downloadApp{
  box-sizing: border-box;
}
.downloadApp p{
  height: 0.76rem;
  width: 4.4rem;
  margin:0.35rem auto 0.34rem;

}
.downloadApp p img{
  width: 100%;
  height: 100%;
}
.programPage{
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  /* text-align: left; */
} 
.comPage-compere{
   width: 100%;
}
.programContainer{
  box-sizing: border-box;
  padding: 0.24rem 0.24rem 0rem 0.24rem;
}
.comMessage{
  width: 100%;
  display: flex;
  /* border: solid 1px; */
}
.comImg{
  width: 1.88rem;
  height: 1.88rem;
  vertical-align: middle;
  /* border: solid 1px; */
}
.comImg>img{
  width: 100%;
  height: 100%;
  border-radius:0.1rem;
}
.comMsg{
  text-align: left;
  line-height: 0.25rem;
}
.comMsg>.comname{
  height: 0.4rem;
  color: rgba(34, 34, 34);
  font-size:0.84rem;
  font-weight:bold;
  color:rgba(51,51,51,1);
  line-height:0.4rem;
  font-size: 0.42rem;
}
.programMsg{
  font-size:0.24rem;
  font-weight:400;
  color:rgba(102,102,102,1);
  margin-left: 0.01rem;
}
.programMsg p font{
  width: 1.12rem;
  display: inline-block;
}

.introce{
  margin-top: 0.31rem;
  height: 0.23rem;
  /* border: solid 1px; */

}
.broadcastTime{
  margin-top: 0.24rem;
  height: 0.23rem;
  /* border: solid 1px; */
}
.attFens{
  margin-top: 0.22rem;
  height: 0.2rem;
  display: flex;
  align-items: center;
  /* border: solid 1px; */
}
.compereMsg{
  margin-top: 0.35rem;
  /* border: solid 1px red; */
  display: flex;
  align-items: center;

}
.hosts{
  font-size:0.24rem;
  /* font-family:PingFang-SC-Medium; */
  font-weight:500;
  color:rgba(153,153,153,1);
  margin-right: 0.25rem;
}
.headPhoto{
  width: 1.1rem;
  margin-right: 0.32rem;
  
}
.headPhoto img{
  width: 100%;
  height: 100%;
  border-radius: 100%;
}
.timeAndhosts{
  height:0.74rem;
  background:rgba(248,248,248,1);
  /* border: solid 1px; */
  margin-top: 0.32rem;
  /* font-family:PingFang-SC-Medium; */
  font-weight:500;
  color:rgba(153,153,153,1);
  line-height:0.74rem;
  /* padding-left:5rem;  */
  margin-bottom: 0.44rem;
  font-size: 14px;
}
.timeAndhosts img{
  width: 0.24rem;
  height: 0.24rem;
  vertical-align: middle;
}
.timeAndhosts img:first-of-type{
  margin: 0 0.38rem 0 0.14rem;
}
.timeAndhosts img:last-of-type{
  margin: 0 0.12rem 0 0.13rem;
}
.min-photo{
  position: relative;
}
.min-name{
  font-size: 0.24rem;
}
.headPhoto .addPng{
  position: absolute;
  width: 0.36rem;
  height: 0.36rem;
  left: 0.72rem;
  top:0.75rem;
}

</style>
